import { FormattedMessage } from 'components/shared/Intl';
import { useState } from 'react';
import { Card, CardBody, CardFooter } from 'react-bootstrap';

import { Drawing as DrawingComponent } from './Drawing/Drawing';
import type { IScreenshotProps } from './model';
import { Mode } from './model';
import { Preview as PreviewComponent } from './Preview/Preview';

export function Screenshot({ screenshot, isFrozen, onRevert, onChange, onDrawing, onPreview }: IScreenshotProps) {
  const [width, setWidth] = useState(300);
  const [hasScreenshotBeenChanged, setScreenshotChanged] = useState(false);
  const [mode, setMode] = useState(Mode.Preview);

  function updateWidth(element: HTMLDivElement): void {
    if (element?.clientWidth) {
      setWidth(element.clientWidth);
    }
  }

  function revert() {
    setScreenshotChanged(false);
    onRevert();
  }

  function update(screenshot: HTMLCanvasElement): void {
    setScreenshotChanged(true);
    setMode(Mode.Preview);
    onChange(screenshot);
    onPreview();
  }

  function onModeChanged(newMode: Mode) {
    setMode(newMode);
    if (newMode === Mode.Drawing) {
      onDrawing();
    } else {
      onPreview();
    }
  }

  return (
    <div className="mt-4">
      {!screenshot ? (
        <div>
          <p className="text-center">
            <strong>
              <FormattedMessage id="lifeRing.screenshotIsProcessing" />
            </strong>
          </p>
        </div>
      ) : (
        <Card className="card-bordered">
          <CardBody>
            <div ref={updateWidth}>
              {isFrozen ||
                (mode === Mode.Preview && (
                  <PreviewComponent
                    canRevert={hasScreenshotBeenChanged}
                    canvas={screenshot}
                    isToolbarHidden={isFrozen}
                    onModeChanged={onModeChanged}
                    onRevert={revert}
                  />
                ))}
              {!isFrozen && mode === Mode.Drawing && (
                <DrawingComponent canvas={screenshot} onModeChanged={onModeChanged} onSave={update} width={width} />
              )}
            </div>
          </CardBody>
          <CardFooter>
            <span className="text-info">
              <em className="icon me-1">info</em>
              <FormattedMessage id="lifeRing.screenshotRenderingMightBeDifferent" />
            </span>
          </CardFooter>
        </Card>
      )}
    </div>
  );
}
